module.exports = __webpack_public_path__ + "static/media/Calendar3.895d1746.svg";